module.exports = {
  index: {
    aboutXiHe: "About Sailuk",
    aboutDesc: "Professional rivet manufacturer in china",
    aboutName: "Sailuk Rivet Co., Ltd.",
    product: "More",
    contact: {
      desc: "Are you interested in our products? Welcome to contact us",
      btn: "Contact Us"
    },
    quality: {
      a: "Rigorous monitoring",
      b: "Professional equipment",
      c: "Cutting-edge technology",
      d: "Be trustworthy",
      btn: "Quality Management"
    }
  },
  menu: {
    back_home: "Home",
    product: "Product",
    solution: "Solution",
    about: "About",
    index: "Home",
    search: "Search",
    contact: "Contact",
    backL: "Back",
    back: "Back"
  },
  contact: {
    mobile: "Manager Wu",
    tel: "Company Telephone",
    email: "EMAIL",
    form: {
      name: "NAME *",
      tel: "TEL *",
      title: "TITLE *",
      content: "CONTENT *"
    },
    send: "Send"
  },
  solution: {
    title: "AUTOMOTIVE",
    p1:
      "The accelerated expansion of the global market for new energy vehicles has driven the rapid development of new energy vehicles, and people's demand for new energy vehicle purchases continues to rise.",
    p2:
      "Fasteners are crucial for the reliable operation and structural stability of the various modules in new energy vehicles, exerting an immeasurable influence on their performance and safety.",
    p3:
      "Sailuk Rivet can make the right decision for you from the beginning according to our years of experience in the industry. "
  },
  gdjt: {
    title: "RAIL TRANSPORT",
    p1:
      "In some parts in the high-speed rail, which need to bear the force , structural rivets would be a good choice. Compared to regular rivets, structural rivets have some advantages like higher strength, better looseproof quality and higher safety performance. The types of our structural rivets include but are not limited to MONO-LUK rivet, INTER-LUK rivet and HEM-LUK rivet."
  },
  sdwyj: {
    title: "RADIO TELESCOPE",
    p1: `SAILUK provides panel riveting solution for China's largest radio telescope FAST project, using corrosion-resistant materials for outdoor environment and efficiently manufacturing rivets that meet the requirements of large-scale research facilities.`
  },
  htjs: {
    title: "AEROSPACE ",
    p1: `Sailuk rivets are popular in the application of solar fasten, and Hem-luk rivets ensures a firm and high quality joint that is resistant to all kinds of vibrations. Furthermore, when properly fastened, it provides a tight seal against weather conditions`,
    p2: ``
  },
  gfjgfa: {
    title: "SOLAR",
    p1: "",
    p2:
      "Sailuk provides fastening solutions in the renewable energy, making it possible to have a variety of options for installing solar module.",
    p3:
      "Sailuk rivets are designed for most demanding application scenarios that require excellent  tensile and shear resistance.Easy and fast product installation."
  },
  xnyqc: {
    title: "NEW ENERGY"
  },
  txt: {
    sjyy: "MAIN APPLICATIONS",
    fzlc: " HISTORY",
    xhpk: " QUALITY",
    zzrz: "  CERTIFICATION",
    cpys: "PRODUCT ADVANTAGES"
  },
  footer: {
    left: {
      desc:
        "Annual output of more than 3 billion rivets, advanced equipment, high-quality products, excellent industry solutions, outstanding service, quality is our value.",
      sign: "Sailuk Rivet"
    },
    info: {
      name: "Sailuk Rivet Co., Ltd.",
      address:
        "No.13 Dujia Dongkeng Industrial Zone,  Luohang, Danzao Town , Nanhai District , Foshan City , Guangdong , China ",
      rivet: "Blind rivet"
    },
    web: {
      title: "Website Guide",
      index: "Home",
      about: "About",
      quality: "Quality",
      product: "Product",
      contact: "Contact"
    },
    mobile: {
      title: "Follow Sailuk"
    }
  },
  product: {
    btn: "more",
    length: "Length",
    grip: "Grip Range",
    part: "Part Number",
    shear: "Shear",
    tensile: "Tensile",
    contactus: "Contact Us",
    material: {
      material: "MATERIAL",
      finish: "FINISH"
    }
  },

  about: {
    profileContent:
      "Sailuk has an annual output of more than 3 billion rivets, with a team size of more than 200 employees and 30 technical teams. The factory covers an area of more than 10,000 square meters. Some products are sold to Germany, Korea, Japan, Europe and the United States. Many famous brands have used rivets produced by Sailuk. Quality is our value.",
    profileContent2: "",
    companyDesc:
      "Since its establishment in 1990, nearly 30 years of rivet production experience, adhering to the team's standardized management, solid production technology, bring different partners with efficient business model.",
    efficientCollaboration: {
      p1:
        "Sailuk has its own set of business management methods, which can quickly respond to the needs of users and customize the production of high-quality rivets.",
      p2:
        "The management and technical team, which has accumulated nearly 30 years'experience, has extensive experience in rivet application.",
      p3:
        "Enough to provide uninterrupted products and reliable services, is your trusted good partner.",
      p4: "Custom-made products, become customers",
      p5: "trust first choice",
      quality: "Quality",
      rapid: "Rapid",
      custom: "Customized"
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js